import { useRouter } from "next/router";
import React, { useEffect, useMemo, useRef } from "react";
import Layout from "components/Layout";
import { AppsData } from "data/AppsData";
import classes from "./styles.module.scss";
import Head from "next/head";
import SEO from "components/seo";
import dynamic from "next/dynamic";
import Loader from "components/GameView/common/Loader";
import MinimalAppList from "components/AppsList/MinimalAppList";
import { useMediaQuery } from "hooks/useMediaQuery";
import Text from "components/Brand/Text";
const UnityVerticalDynamic = dynamic(
  () => import("components/GameView/UnityVertical"),
  {
    ssr: false,
    loading: () => <Loader />,
  }
);
const UnityLandscapeDynamic = dynamic(
  () => import("components/GameView/UnityLandscape"),
  {
    ssr: false,
    loading: () => <Loader />,
  }
);
const H5VerticalDynamic = dynamic(
  () => import("components/GameView/H5Vertical"),
  {
    ssr: false,
    loading: () => <Loader />,
  }
);
const Quiz = dynamic(() => import("components/GameView/Quiz"), {
  ssr: false,
  loading: () => <Loader />,
});

export default function GameView({ game, noBack }) {
  const router = useRouter();
  const [isMobile, isDesktop] = useMediaQuery([
    "(max-width: 660px)",
    "(min-width: 1024px)",
  ]);

  const similarGames = useMemo(() => {
    return AppsData.filter(g => g.pathname !== game.pathname).sort(
      () => Math.random() - 0.5
    );
  }, [game]);

  if (game.type === "unityLandscape") {
    return (
      <>
        <Head>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
          />
          <style>
            {
              "body { overflow: hidden; } html { overflow: hidden; } #__next { overflow: hidden; }"
            }
          </style>
        </Head>
        <div
          className={classes.landscapeGame}
          // any first interaction call request for fullscreen
        >
          {/* click and draggable back button */}
          <div className={classes.gameParent}>
            <UnityLandscapeDynamic game={game} noBack={noBack} />
          </div>
          {isDesktop && (
            <div className="hidden h-auto  flex-1 overflow-y-hidden px-4 lg:block ">
              <MinimalAppList
                title="Play Similar Games"
                apps={similarGames}
                vertical
                cardSize={100}
                className="mb-4 max-h-[90vh] flex-wrap pr-4"
              />
            </div>
          )}
        </div>
      </>
    );
  }
  if (game.type === "h5") {
    return (
      <>
        <Head>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
          />
          <style>
            {
              "body { overflow: hidden; } html { overflow: hidden; } #__next { overflow: hidden; }"
            }
          </style>
        </Head>
        <div className={classes.gameParent}>
          <div className="m-auto hidden flex-1 px-4 text-center lg:block"></div>

          <H5VerticalDynamic game={game} noBack={noBack} />

          <div className="m-auto hidden flex-1 px-4 text-center lg:block"></div>
        </div>
      </>
    );
  }
  if (game.type === "quiz") {
    return (
      <>
        <Head>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
          />
        </Head>
        <div
          className={classes.gameParent}
          // any first interaction call request for fullscreen
        >
          {/* click and draggable back button */}
          {/* {isDesktop && <LeftTowerBannerAd />} */}
          <div className="m-auto hidden flex-1 px-4 text-center lg:block"></div>
          <Quiz game={game} noBack={noBack} />
          {/* {isDesktop && <RightTowerBannerAd />} */}
          <div className="m-auto hidden flex-1 px-4 text-center lg:block"></div>
        </div>
      </>
    );
  }
  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <style>
          {
            "body { overflow: hidden; } html { overflow: hidden; } #__next { overflow: hidden; }"
          }
        </style>
      </Head>
      <div
        className={classes.gameParent}
        // any first interaction call request for fullscreen
      >
        {/* click and draggable back button */}
        {/* {isDesktop && <LeftTowerBannerAd />} */}
        <div className="m-auto hidden flex-1 px-4 text-center lg:block"></div>
        <UnityVerticalDynamic game={game} noBack={noBack} />
        {/* {isDesktop && <RightTowerBannerAd />} */}
        <div className="m-auto hidden flex-1 px-4 text-center lg:block"></div>
      </div>
    </>
  );
}
